module.exports = __webpack_public_path__ + "static/media/menu.82acee35.svg";